export const TRIAL_PAGES_V1A = 'v1a';
